export const Team = (props) => {
    return (
        <div className="w-2/5 h-100 flex flex-col items-center justify-evenly">
            <img src={props.logo} alt="Home team logo" className = "h-1/4"/>
            <p className="text-xl text-center">{props.team}</p>
            <div className="h-1/4 w-100"></div>
        </div>
    )
}